import { useEffect, useState } from 'react';
import api from '../services/api';

/**
 * User-level portfolio totals (all accessible stores) for the dashboard date range.
 */
export default function usePortfolioDashboard(
  highlightProfileId,
  { startDate, endDate, previousStart, previousEnd, enabled = true } = {}
) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const rangeKey = [startDate, endDate, previousStart, previousEnd, highlightProfileId].join('|');

  useEffect(() => {
    if (!enabled || !startDate || !endDate || !previousStart || !previousEnd) {
      setData(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    api
      .post('/stores/portfolio-dashboard', {
        startDate,
        endDate,
        previousStart,
        previousEnd,
        highlightProfileId: highlightProfileId || undefined,
      })
      .then((res) => {
        if (cancelled || !res.data?.success) return;
        setData(res.data);
      })
      .catch(() => {
        if (!cancelled) setData(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [rangeKey, enabled, highlightProfileId, startDate, endDate, previousStart, previousEnd]);

  return { portfolio: data, loading };
}
